export const createJiraIssueUserPreferencesKey = (repoUuid: string) =>
  `default-jira-project:${repoUuid}`;

export const createJiraTabFiltersUserPreferencesKey = (repoUuid: string) =>
  `jira-tab:filters:${repoUuid}`;

export const createJiraTabCreateIssueUserPreferencesKey = (repoUuid: string) =>
  `jira-tab:create-issue:${repoUuid}`;
